import { render, staticRenderFns } from "./GogoSafe.vue?vue&type=template&id=ac6ec31c&scoped=true"
var script = {}
import style0 from "./GogoSafe.vue?vue&type=style&index=0&id=ac6ec31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6ec31c",
  null
  
)

export default component.exports